import React from "react";
import { Typography } from "@mui/material";
import "./Footer.css";
const Footer = () => {
  return (
    <footer>
      <div className="text">
        <span>
          Build and design by{" "}
          <a href="https://github.com/morshedalam3" target="_blank">
            Morshed Alam
          </a>
        </span>

        <Typography variant="h6" sx={{ color: "#fff" }}></Typography>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="footer-copyright">
            <span style={{ color: "#ff0266" }}>
              {" "}
              Copyright &copy; {new Date().getFullYear()} All rights reserved.
            </span>
            <div
              style={{
                borderBottom: "2px solid #fff",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
